import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import type { ChangeEvent } from 'react'
import styled from 'styled-components'

import { QUERY_KEY } from '../../../constants'

import { toast } from '../../../utils'

import { useNavigate } from '../../../hooks/useNavigate'

import { registerQna } from '../../../api/qna'

import { Head } from '../../../components/head/Head'
import { Wrap } from '../../../components/container/Wrap'
import { Content } from '../../../components/container/Content'
import { Button } from '../../../components/button'
import { Input } from '../../../components/input'
import { Text } from '../../../components/text'
import { Footer } from '../../../components/footer'
import { Header } from '../../../components/header'
import { HEAD_INFO } from './Qna'

export function QnaRegister() {
  const [validateStatus, setValidateStatus] = useState<boolean>(false)
  const [inputValues, setInputValues] = useState({
    title: '',
    content: '',
  })
  const { title, content } = inputValues

  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const { mutate } = useMutation({
    mutationFn: registerQna,
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [QUERY_KEY.qnaList] })
      setInputValues({ title: '', content: '' })
      toast('✓ 문의사항 접수가 완료되었습니다.')
      navigate(-1)
    },
    onError: (error) => {
      toast('문의사항 접수에 실패했어요.', error)
    },
  })

  const validate = () => setValidateStatus(!!title && !!content)

  const onChangeInput = ({ currentTarget: { name, value } }: ChangeEvent<HTMLInputElement>) => {
    if (name === 'title' && value.length > 35) return
    setInputValues({ ...inputValues, [name]: value })
  }

  const onRegisterQna = () => {
    mutate({ title, content })
  }

  useEffect(() => {
    validate()
  }, [title, content])

  return (
    <>
      <Head {...HEAD_INFO} />
      <Wrap>
        <Header type="SUB" title="1:1문의하기" />
        <Content>
          <TitleContainer>
            <Text size={18} weight={600}>
              문의 제목
            </Text>
            <Input placeholder="제목을 입력해주세요. (최대 35자)" name="title" value={title} onChange={onChangeInput} />
          </TitleContainer>
          <ContentContainer>
            <Text size={18} weight={600}>
              문의 내용
            </Text>
            <Input.Textarea
              placeholder="내용을 입력해주세요."
              name="content"
              value={content}
              $height={400}
              onChange={onChangeInput}
            />
          </ContentContainer>
        </Content>
        <Footer>
          <Button type="primary" size="large" disabled={!validateStatus} block={true} onClick={onRegisterQna}>
            {validateStatus ? '문의하기' : '내용을 입력해주세요.'}
          </Button>
        </Footer>
      </Wrap>
    </>
  )
}

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 20px;
`

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 20px;
`
